import { Signal } from 'libs/signals';

const prevNextTabButtonsSignal = Signal({
  eventKeys: [],
  activeKey: '',
});

export default prevNextTabButtonsSignal;
